(function () {
    'use strict';

    angular.module('app.controllers')
        .controller('TrendCtrl', TrendCtrl)
    ;

    /* @ngInject */
    function TrendCtrl(DataFactory) {

        var vm = this;

        DataFactory.getTableData('trend').then(function (data) {

            var trendData = [];

            angular.forEach(data.rows, function (row) {

                var r = {
                    Category: row.values[0],
                    Tablet: row.values[1],
                    Desktop: row.values[2],
                    Smartphone: row.values[3]
                };

                trendData.push(r);
            });

            vm.trendData = trendData;

            var fo = DataFactory.getFilterOptions();
            vm.source = 'Digital Content Ratings, Text, ' + fo[0].label + ', People 2+, Monthly Total.'
        });
    }

})();
